import mobilePhone from "./mobilePhone";
import ipPhone from "./ipPhone";

/**
 * 参考: 総務省 電話番号に関するQ&A
 * @see https://www.soumu.go.jp/main_sosiki/joho_tsusin/top/tel_number/q_and_a.html
 */
const telephoneRegexp = new RegExp(
  /^0(?:\d{1}[-]?\d{4}|\d{2}[-]?\d{3}|\d{3}[-]?\d{2}|\d{4}[-]?\d{1})[-]?\d{4}$/
);

/**
 * 参考: wikipedia
 * @see https://ja.wikipedia.org/wiki/%E3%83%95%E3%83%AA%E3%83%BC%E3%83%80%E3%82%A4%E3%83%A4%E3%83%AB
 */
const freeDialRegexp = new RegExp(
  /^(?:0120[-]?\d{3}[-]?\d{3}|0800[-]?\d{3}[-]?\d{4})$/
);

const tel = (value: string): boolean => {
  if (value === "") {
    return true;
  }

  return (
    telephoneRegexp.test(value) ||
    freeDialRegexp.test(value) ||
    mobilePhone(value) ||
    ipPhone(value)
  );
};

export default tel;
